import luxuryEscapesTheme, { luxuryEscapesBorderRadii, luxuryEscapesDefaultPalette, luxuryEscapesInversePalette } from './luxuryescapes'
import { baseThemeShadows } from './shadows'

export const leAgenthubDefaultPalette: App.Design.Palette<string> = {
  ...luxuryEscapesDefaultPalette,
}

export const leAgenthubInversePalette: App.Design.Palette<string> = {
  ...luxuryEscapesInversePalette,
}

export const leAgentHubShadows: App.Design.Shadows<string> = { ...baseThemeShadows }
export const leAgentHubBorderRadii: App.Design.BorderRadii<string> = { ...luxuryEscapesBorderRadii }

const leAgenthubTheme: App.Design.Theme = {
  ...luxuryEscapesTheme,
}

export default leAgenthubTheme
